module.exports = __webpack_public_path__ + "static/img/5.746492d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/5.svg
// module id = hQTV
// module chunks = 0